export const environment = {
  production: false,
  API_URL: "https://apicmgwdev.healent.com",
  API_DOMAIN_LEGACY: "dev.healent.com",
  API_AUTH_URL: "https://apipracticegwdev.healent.com",
  environment: "development",
  domain: "healent.com",
  slug: "heal",
  this_angular_commit_id: "a0865a0202afa140a01915b6eb8c0a694562b2e7",
  this_api_auth_commit_id: "123456",
  this_api_campaignmanager_commit_id: "b6c5265d5e7b09d96f6ded195335de6c3751040c"
};
